function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15 10.88H9v2.25h6v-2.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1.88H9v1.88c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-9c0-.41.34-.75.75-.75s.75.34.75.75v1.88h6V7.5c0-.41.34-.75.75-.75s.75.34.75.75v9z"
})));